import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import isDomElement from 'utils/predicates/dom/isDomElement.util';

const L = logger('domElement');

const domElement = (selector) => {
  try {
    if (isDomElement(selector)) return selector;

    const stringifiedSelector = fromAnyToTrimmed(selector);

    return document.querySelector(stringifiedSelector);
  } catch (e) {
    L.warn('()', e, 'selector:', selector);
    return null;
  }
};

// noinspection JSUnusedGlobalSymbols
export default domElement;
